import { render, staticRenderFns } from "./product-card.vue?vue&type=template&id=57633145&scoped=true"
import script from "./product-card.vue?vue&type=script&lang=js"
export * from "./product-card.vue?vue&type=script&lang=js"
import style0 from "./product-card.vue?vue&type=style&index=0&id=57633145&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57633145",
  null
  
)

export default component.exports